module.exports = __webpack_public_path__ + "static/media/Icon_Standby_Opacity70.80393758.png";